<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header bg-black" style="color: white">
          <slot name="header">{{ $t("common.notice") }} </slot>
        </div>
        <div class="modal-body">
          <div slot="body">
            <!-- The server maintenance is scheduled for July 9th from 9:00 to 14:00. <br>
In the meantime, service downtime may occur about 5 mins intermittently. Please understand.  -->
            <!-- The server maintenance is scheduled for 9th September from 8:00 to
            18:00(GMT+9). <br />
            Thank you for understanding in advance. -->
            <p>공지사항 제목</p>
            <div>공지사항 내용</div>
          </div>
        </div>
        <div class="custom_modal_footer d-flex justify-content-between">
          <slot name="footer"> </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0) !important;
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 850px;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 0px;
  padding: 20px;
  line-height: 23px;
}

.modal-default-button {
  float: right;
}
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.custom_modal_footer {
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.modal-body,
.modal {
  color: #666 !important;
}
</style>
